// tslint:disable:jsx-no-lambda (autogenerated)
// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-any (autogenerated)
import * as React from 'react';
import Radium from '../../styling/rostelecom-radium';
import Color from 'color';
import InternationalizedComponent from '../../../../base/internationalized-component';
import { IRostelecomStyleParamsStoreState } from '../../styling/rostelecom-styles-store';
import { IWindowSizeStoreState } from '../../../../../services/window-size/window-size-store';
import { getPropsForField, validateOnFormSubmit } from '../../../../../services/forms/form-helper';
import { ILoginStoreState } from '../../../../../services/login/login-store';
import * as loginActions from '../../../../../services/login/login-actions';
import LoginInput from './elements/login-input';
import LoginButton from './elements/login-button';
import { FormattedHTMLMessage } from 'react-intl';
import { IReactRadiumFreeStyles } from '../../../../base/radium-types';
import RadioButton from '../../reusable/radio-button';
import { setLoginState } from '../../../../../services/login/login-actions';
export interface ILoginPageProps {
    styleParams: IRostelecomStyleParamsStoreState;
    windowSize: IWindowSizeStoreState;
    loginStore?: ILoginStoreState;
}

export interface ILoginPageState {
    formState?: any;
    restoreBy: 'username' | 'email';
}

@Radium
class RestorePasswordPage extends InternationalizedComponent<ILoginPageProps, ILoginPageState> {
    // tslint:disable-next-line:typedef (autogenerated)
    constructor(props, opts) {
        super(props, opts);
        this.doRestorePassword = this.doRestorePassword.bind(this);
        this.initialize();

        this.state = { ...this.state, restoreBy: 'username' };
    }

    private getStyles(): IReactRadiumFreeStyles {
        const styleParams = this.props.styleParams;
        const windowWidth = this.props.windowSize.width;
        const login = this.props.loginStore;
        const visible = login.page === 'restore-password';
        return {
            form: {
                position: visible ? 'relative' : 'absolute',
                zIndex: visible ? 20 : 0,
                opacity: visible ? 1 : 0,
                top: 0,
                left: 0,
                width: '100%',
                transition: 'opacity 0.15s ease-out, z-index 0.15s ease-out'
            },
            subHeader: {
                fontSize: '16px',
                lineHeight: '18px',
                marginTop: 0,
                marginRight: 0,
                marginBottom: 20,
                widthFix: windowWidth,
                marginLeftFix: -(windowWidth - 256) / 2,
                textAlign: 'center',
                padding: 0,
                color: Color(styleParams.neutralColor)
                    .darken(0.6)
                    .hexString()
            },
            checkboxOuter: {
                position: 'relative',
                textAlign: 'left'
            },
            buttonsOuter: {},
            linkStyle: {
                marginTop: 20,
                display: 'block',
                color: styleParams.complementaryMediumDarkColor
            },
            serverError: {
                display: 'block',
                color: styleParams.baseAccentColor,
                minHeight: 16,
                lineHeight: '16px',
                fontSize: '14px',
                marginTop: 8,
                marginBottom: 8
            },
            radioBtnsWrapper: {
                verticalAlign: 'top',
                marginBottom: 10
            },
            btnStyleDefault: {
                verticalAlign: 'top',
                backgroundColor: styleParams.baseLightColor,
                border: '1px solid ' + styleParams.baseMediumDarkColor,
                borderRadius: '2px 0 0 2px',
                color: styleParams.baseMediumDarkColor,
                fontSize: '12px',
                cursor: 'pointer',
                padding: 0,
                boxSizing: 'border-box',
                width: '50%',
                height: '40px',
                lineHeight: '40px',
                fontWeight: 'normal'
            },
            btnStyleComplementary: {
                backgroundColor: styleParams.baseLightColor,
                border: '1px solid ' + styleParams.complementaryAccentColor,
                borderRadius: '2px 0 0 2px',
                color: styleParams.complementaryAccentColor,
                fontSize: '12px',
                cursor: 'pointer',
                padding: 0,
                boxSizing: 'border-box',
                width: '50%',
                height: '40px',
                lineHeight: '40px',
                fontWeight: 'normal',
                marginLeft: 7
            }
        };
    }

    // tslint:disable-next-line:member-ordering (autogenerated)
    private formFields: IFormFieldDescriptor[] = [
        {
            id: 'login',
            validate: (value, oldValue) => {
                if (!value || value.length === 0) {
                    return [this.i18n('js.auth.pages.login.fields.login.required')];
                }
                return [];
            }
        }
    ];

    private getFormDescriptor = (): IFormDescriptor => {
        return {
            value: this.props.loginStore,
            state: this.state.formState,
            onChange: value => {
                loginActions.setLoginState(value);
            },
            onStateChange: state => {
                this.setState({ formState: state });
            },
            fields: this.formFields
        };
    };

    // tslint:disable-next-line:typedef (autogenerated)
    private async doRestorePassword(evt) {
        if (evt && evt.preventDefault) {
            evt.preventDefault();
        }
        const form = this.getFormDescriptor();
        const loginForm = this.props.loginStore;

        if (validateOnFormSubmit(form, loginForm)) {
            await loginActions.restorePassword(loginForm.login, this.state.restoreBy === 'email');
        }
    }

    public resetAndGoToLogin = (evt: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        setLoginState({restoringPasswordSuccess: false});
        loginActions.setPage('login');
        if (evt && evt.preventDefault) {
            evt.preventDefault();
            evt.stopPropagation();
        }
    }

    // tslint:disable-next-line:typedef member-access (autogenerated)
    renderSuccess(styles) {
        return (
            <form
                key="restorePasswordRoot"
                onSubmit={() => loginActions.setPage('login')}
                style={styles.form}
            >
                <h2 style={styles.subHeader}>
                    <FormattedHTMLMessage id="js.auth.pages.login.messages.restore-password-success" />
                </h2>
                <a
                    key="restore-pass-return"
                    style={styles.linkStyle}
                    href="#"
                    onClick={this.resetAndGoToLogin}
                >
                    {this.i18n('js.auth.pages.login.buttons.go-to-login-from-reset')}
                </a>
            </form>
        );
    }

    private invertStyle(style: React.CSSProperties): React.CSSProperties {
        return {
            color: this.props.styleParams.baseLightColor,
            backgroundColor: style.color
        };
    }

    private onRadioChange = () => {
        this.setState({
            restoreBy: this.state.restoreBy === 'username' ? 'email' : 'username'
        });
    };

    private renderRadioButtons(): React.ReactElement<void> | void {
        /*************************************
****************************************
**************************************
**********************************************************
***************************************************************************************************

****************
*************************************************
****************************
***************************************
************************************************************************
**********************************************************************************
*****************************************
*****************************************************************
************************************
*************************************************
******************
****************************
********************************************
************************************************************************
*******************************************************************************
*****************************************
**************************************************************
*********************************
*************************************************
******************
******************
**********
*********************************/
    }

    public render(): React.ReactElement<void> {
        const styles = this.getStyles();
        const styleParams = this.props.styleParams;
        const login = this.props.loginStore;
        const form = this.getFormDescriptor();
        const loginProps = getPropsForField(form, 'login');
        const disabled =
            login.authorizing ||
            login.authorized ||
            login.resettingPassword ||
            login.restoringPassword;
        if (login.restoringPasswordSuccess) {
            return this.renderSuccess(styles);
        }

        const inputLabel =
            this.state.restoreBy === 'username'
                ? this.i18n('js.auth.pages.login.fields.login.label')
                : this.i18n('js.auth.pages.login.fields.email.label');

        return (
            <form key="restorePasswordRoot" onSubmit={this.doRestorePassword} style={styles.form}>
                <h2 style={styles.subHeader}>
                    <FormattedHTMLMessage id="js.auth.pages.login.titles.restore-password" />
                </h2>
                {this.renderRadioButtons()}
                <LoginInput
                    key="login"
                    {...{
                        label: inputLabel,
                        formProps: loginProps,
                        styleParams,
                        disabled
                    }}
                />
                <div key="buttons" style={styles.buttonsOuter}>
                    <div key="serverError" style={styles.serverError}>
                        {login && login.restoringPasswordError}
                    </div>
                    <LoginButton
                        {...{
                            disabled,
                            styleParams,
                            onClick: this.doRestorePassword,
                            label: this.i18n('js.auth.pages.login.buttons.restore-password')
                        }}
                    />
                </div>
                <a
                    key="restore-pass-return"
                    style={styles.linkStyle}
                    href="#"
                    onClick={this.resetAndGoToLogin}
                >
                    {this.i18n('js.auth.pages.login.buttons.go-to-login')}
                </a>
            </form>
        );
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default RestorePasswordPage;
